if (typeof doQuickAddAppCheck === 'undefined') {
  var doQuickAddAppCheck = function () {
    const element = document.querySelector('div.add-to-cart-quick.add-to-cart-absolute.addtc-circle ul');
    if (element && !element.classList.contains('flag')) {
      element.classList.add('flag');
      const backdrop = document.createElement('div');
      backdrop.classList.add('mobile-backdrop');
      document.body.append(backdrop);
      backdrop.innerHTML = element.parentElement.innerHTML;
      backdrop.insertAdjacentHTML('afterbegin', '<div class="drop"></div>');
      const mobileli = [...backdrop.querySelectorAll('li')];
      const desktopli = [...element.querySelectorAll('li')];
      mobileli.forEach((li, index) => li.addEventListener('click', () => {
        desktopli[index].click();
        document.body.removeChild(backdrop);
      }));
      backdrop.addEventListener('click', () => {
        document.body.removeChild(backdrop);
      });
    }
  };
}
if (typeof quickAddAppCheck === 'undefined') {
  var quickAddAppCheck = setInterval(doQuickAddAppCheck, 100);
}

if (typeof doWaitForAddtc === 'undefined') {
  var doWaitForAddtc = () => {
    let quickATCButtons = document.querySelectorAll('.addtc-button');
    if (quickATCButtons.length > 0) {
      clearInterval(waitForAddtc);
      for (let i = 0; i < quickATCButtons.length; i++) {
        const el = quickATCButtons[i];
        el.closest('.grid__item').classList.add('un8');
        el.addEventListener('click', (e) => {
          const watchForSizeBlock = () => {
            let block = e.target.parentElement.querySelector('.addtc-dropdown.flag');
            if (block) {
              clearInterval(sizeBlockWatch);
              let productTitle = e.target.parentElement.parentElement.querySelector('.grid-product__title').innerText;
              let titleBlock = document.createElement('span');
              titleBlock.innerHTML = productTitle + '<span>SELECT SIZE</span>';
              titleBlock.classList.add('sizeSelectTitle');
            }
          };
          let sizeBlockWatch = setInterval(watchForSizeBlock, 200);
        });
      }
    }
  };
}
if (typeof waitForAddtc === 'undefined') {
  var waitForAddtc = setInterval(doWaitForAddtc, 100);
}